import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinjunnartaluka() {



  const cardData =
  {
    keyword: 'Cab Service in Junnar Taluka',
    heading: 'Sanavi Travels: Cab Service in Junnar Taluka',
    headingDescription: 'Cab Service in Junnar Taluka offers reliable, comfortable, and budget-friendly taxi solutions for local travel, outstation trips, sightseeing tours, airport transfers, and special occasions. Choose from a wide range of well-maintained vehicles including Swift Dzire, Etios, Ertiga, Innova Crysta, and SUVs, driven by experienced and courteous chauffeurs. With timely pickups, transparent fares, flexible packages, and 24/7 booking support, cab service in Junnar Taluka ensures a safe, smooth, and hassle-free travel experience to Pune, Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, and nearby destinations.',

    top: 'Top Places to Visit in Junnar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Junnar Town",
    "description": "Junnar is a historic town in Pune district with deep roots in ancient Indian history, trade, and culture. Once an important center during the Satavahana and later Maratha periods, Junnar is surrounded by hills, forts, and ancient caves. The town offers a unique blend of archaeology, spirituality, rural life, and natural beauty, making it an important heritage destination in Maharashtra."
  },
  {
    "title": "Lenyadri Ganpati Temple",
    "description": "Lenyadri Ganpati Temple is one of the eight revered Ashtavinayak temples of Maharashtra. Carved into a Buddhist rock-cut cave, the temple is dedicated to Lord Ganesha and holds immense spiritual significance. Reached by climbing stone steps, the cave offers a serene atmosphere along with panoramic views of the surrounding hills."
  },
  {
    "title": "Shivneri Fort",
    "description": "Shivneri Fort is the birthplace of Chhatrapati Shivaji Maharaj and one of the most important historical forts in India. The fort is well-preserved with strong fortifications, water tanks, temples, and the Shiv Janmabhoomi temple. Trekking to Shivneri provides a powerful connection to Maratha history and offers stunning views of the surrounding region."
  },
  {
    "title": "Manmodi Caves",
    "description": "The Manmodi Caves are a group of ancient Buddhist rock-cut caves dating back to the Satavahana period. Known for their simplicity, water cisterns, and meditation halls, these caves highlight the spiritual and architectural heritage of ancient India."
  },
  {
    "title": "Tulja Caves",
    "description": "Tulja Caves are lesser-known Buddhist caves located near Junnar. These caves are valued for their peaceful surroundings and historical importance, offering visitors a quiet and reflective heritage experience."
  },
  {
    "title": "Naneghat",
    "description": "Naneghat is an ancient mountain pass near Junnar that once served as a major trade route connecting the Deccan Plateau to the Konkan coast. Famous for its rock-cut inscriptions, giant stone jar, and panoramic viewpoints, Naneghat is also a popular trekking destination and monsoon attraction."
  },
  {
    "title": "Harishchandragad (Nearby)",
    "description": "Located close to Junnar, Harishchandragad is a majestic hill fort known for the iconic Konkan Kada cliff, ancient temples, and challenging treks. It attracts adventure seekers, photographers, and history lovers from across Maharashtra."
  },
  {
    "title": "Junnar Vineyards and Farmlands",
    "description": "The fertile lands around Junnar are known for grape cultivation and vineyards. Visitors can explore agricultural landscapes, learn about farming practices, and enjoy scenic countryside views."
  },
  {
    "title": "Ancient Temples of Junnar",
    "description": "Junnar is dotted with old temples dedicated to Lord Shiva, Goddess Parvati, and local deities. These temples reflect traditional architecture and play a vital role in the cultural and spiritual life of the region."
  },
  {
    "title": "Monsoon Landscapes and Waterfalls",
    "description": "During the monsoon season, the hills around Junnar come alive with greenery, mist, and seasonal waterfalls. The region becomes a visual treat for nature lovers and photographers, offering refreshing weather and breathtaking scenery."
  }
]
,



"services": [
{
"name": "Cab Service in Junnar Taluka",
"description": "Cab Service in Junnar Taluka offers reliable, comfortable, and safe taxi services for local travel, sightseeing, and outstation trips. With well-maintained vehicles, professional drivers, and flexible booking options, it ensures a smooth and hassle-free journey. Ideal for families, tourists, corporate travelers, and daily commuters, it provides convenient pickup and drop services, customizable travel plans, and excellent customer support across Junnar Taluka and nearby areas."
},
{
"name": "Taxi Service Junnar",
"description": "Taxi Service Junnar delivers efficient and professional cab services for city travel, airport transfers, long-distance trips, and daily commuting. With courteous drivers, modern vehicles, and punctual service, it ensures safe, comfortable, and convenient transportation for residents, tourists, and corporate travelers in and around Junnar."
},
{
"name": "AC Cab Junnar",
"description": "AC Cab Junnar provides fully air-conditioned cabs for a comfortable and refreshing travel experience. Perfect for long-distance trips, family outings, corporate travel, and tourist journeys, these cabs offer smooth rides, modern interiors, and professional drivers who prioritize passenger safety and convenience while traveling across Junnar Taluka and nearby regions."
},
{
"name": "Local Cab Junnar",
"description": "Local Cab Junnar offers reliable and timely taxi services within Junnar for errands, shopping, sightseeing, and daily commuting. With well-maintained vehicles, experienced drivers, and flexible scheduling, it ensures a safe, convenient, and hassle-free travel experience for passengers navigating Junnar and its surrounding areas."
},
{
"name": "Outstation Cab Junnar",
"description": "Outstation Cab Junnar specializes in long-distance travel to nearby cities, tourist destinations, and weekend getaways. With spacious vehicles, skilled drivers, and customizable itineraries, it ensures safe, convenient, and enjoyable journeys for families, groups, and solo travelers venturing outside Junnar Taluka."
},
{
"name": "Affordable Cab Junnar",
"description": "Affordable Cab Junnar combines budget-friendly pricing with reliable and comfortable taxi services. Suitable for families, tourists, corporate travelers, and daily commuters, it provides well-maintained vehicles, professional drivers, and timely service, making it a dependable choice for cost-conscious passengers traveling in and around Junnar."
},
{
"name": "Chauffeur Driven Cab Junnar",
"description": "Chauffeur Driven Cab Junnar offers professional drivers who manage navigation, traffic, and schedules, allowing passengers to enjoy a stress-free journey. Perfect for VIP clients, corporate teams, families, and tourists, it ensures smooth, safe, and comfortable travel throughout Junnar Taluka and neighboring regions."
},
{
"name": "Best Cab Service Junnar",
"description": "Best Cab Service Junnar is known for punctuality, well-maintained vehicles, and excellent customer service. Offering city travel, airport transfers, sightseeing tours, and outstation trips, it provides reliable, safe, and comfortable transportation for individuals, families, and corporate clients traveling within Junnar Taluka and beyond."
},
{
"name": "Tourist Cab Junnar",
"description": "Tourist Cab Junnar caters to travelers exploring Junnar and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a seamless sightseeing experience, allowing tourists to enjoy historical, cultural, and scenic destinations without worrying about transportation logistics."
},
{
"name": "Airport Cab Junnar",
"description": "Airport Cab Junnar provides timely pickup and drop services to and from nearby airports. With professional drivers, spacious vehicles, and flexible scheduling, it ensures a smooth, stress-free travel experience for business travelers, tourists, and families flying in or out of Junnar Taluka."
},
{
"name": "Corporate Cab Junnar",
"description": "Corporate Cab Junnar offers dedicated taxi services for executives, employees, and business teams. With punctual pickups, clean vehicles, and courteous drivers, it ensures safe, reliable, and efficient transportation for office travel, meetings, and corporate events in Junnar Taluka and surrounding areas."
},
{
"name": "Online Cab Booking Junnar",
"description": "Online Cab Booking Junnar allows passengers to reserve cabs quickly and conveniently with instant confirmation. With multiple vehicle options, transparent pricing, and flexible scheduling, it simplifies travel planning for families, tourists, corporate clients, and local commuters traveling to or from Junnar Taluka."
},
{
"name": "Family Cab Junnar",
"description": "Family Cab Junnar provides spacious and comfortable vehicles suitable for family travel. Designed to accommodate passengers of all ages, it ensures safe, convenient, and enjoyable journeys for family outings, vacations, day trips, and sightseeing tours within Junnar Taluka and nearby regions."
},
{
"name": "24x7 Taxi Junnar",
"description": "24x7 Taxi Junnar offers round-the-clock cab services to ensure passengers have reliable transportation anytime. With professional drivers, well-maintained vehicles, and prompt response times, it provides safe and convenient travel solutions for emergencies, late-night rides, airport transfers, and other travel needs in Junnar Taluka."
},
{
"name": "Junnar Travel Taxi",
"description": "Junnar Travel Taxi provides comprehensive cab services for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, and corporate travelers seeking dependable and convenient transportation in Junnar Taluka and surrounding areas."
}
],
"tableData": [
["Cab Service in Junnar Taluka", "Taxi Service Junnar"],
["AC Cab Junnar", "Local Cab Junnar"],
["Outstation Cab Junnar", "Affordable Cab Junnar"],
["Chauffeur Driven Cab Junnar", "Best Cab Service Junnar"],
["Tourist Cab Junnar", "Airport Cab Junnar"],
["Corporate Cab Junnar", "Online Cab Booking Junnar"],
["Family Cab Junnar", "24x7 Taxi Junnar"],
["Junnar Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Junnar Taluka with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Junnar Taluka for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and kept clean to ensure a smooth and pleasant ride throughout Junnar Taluka."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Junnar Taluka routes and surrounding areas, ensuring safe, timely, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Junnar Taluka, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Junnar Taluka."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Junnar Taluka?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Junnar Taluka for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Junnar Taluka?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Junnar Taluka?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Junnar Taluka.'
  },
  {
    question: 'Are the drivers experienced with routes in Junnar Taluka?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Junnar Taluka and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Junnar Taluka.'
  },
  {
    question: 'Is the cab service in Junnar Taluka available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Junnar Taluka to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Junnar Taluka.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Shinde',
    feedback: 'Booked a cab in Junnar Taluka with Sanavi Travels — punctual, clean, and very comfortable ride!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ayesha Patil',
    feedback: 'Excellent cab service in Junnar Taluka with on‑time pickup and professional driver. Highly recommended!',
    rating: 5
  }
];



























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Taxi",
  "name": "Cab Service in Junnar Taluka - Sanavi Travels",
  "description": "Sanavi Travels provides reliable cab services in Junnar Taluka, including AC, local, outstation, airport, and corporate cabs. Perfect for family trips, tourist travel, and 24x7 online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "32"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Cab Service in Junnar Taluka | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC, local, outstation, airport, and corporate cabs in Junnar Taluka with Sanavi Travels. Affordable, chauffeur-driven, and available 24x7. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/148.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinjunnartaluka;